(function trackerAmenitySearchEvents() {
  'use strict';

  const form = document.querySelector('[data-form-search]');

  /**
   * @private
   * getValue: get the value of HTML element.
   *
   * @param {Node} element to get the value.
   */
  function getValue(element) {
    const param = element.dataset.ga4Param;

    if (!element.value) {
      return;
    }

    if (this[param]) {
      this[param] += `-${element.value}`;
      return;
    }
    this[param] = `${element.value}`;
  }

  /**
   * @private
   * getParamsFromElementInputs: get the event params from HTML elements
   *
   * @returns {object} with the attributes to track.
   */
  function getParamsFromElementInputs() {
    const elementValues = document.querySelectorAll('[data-ga4-param]');
    const searchValue = {};
    elementValues.forEach(getValue, searchValue);

    return searchValue;
  }

  /**
   * @private
   * trackSubmitSearch: track submit events.
   *
   */
  function trackSubmitSearch() {
    const eventGa4 = {
      eventName: 'search_filters',
      params: {
        filter_name: this.dataset.formSearch,
        click_target: this.dataset.ga4Click_target,
      },
      eventType: 'GA4Event'
    };
    const paramsFromHtml = getParamsFromElementInputs();
    Object.assign(eventGa4.params, paramsFromHtml);
    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: { data: eventGa4 }
    }));
  }

  if (form) {
    form.addEventListener('submit', trackSubmitSearch);
  }
}());
